import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { Ship, ShipService } from '../../services/ship.service';
import { EmployeeService } from '../../services/employee.service';
import { SubsidiaryService } from '../../services/subsidiary.service';

import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-update-ship',
  templateUrl: './update-ship.component.html',
  styleUrls: ['./update-ship.component.css']
})
export class UpdateShipComponent implements OnInit, OnDestroy {
  
  shipForm: FormGroup;
  sid: string;
  ship: any;

  employees = {};
  subsidiaries = {};

  employeesInit: any;
  subsidiariesInit: any;

  subs: Subscription[] = [];

  constructor(
    private shipService: ShipService,
    private employeeService: EmployeeService,
    private subsidiaryService: SubsidiaryService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute
  ) {
    this.sid = this.activatedRoute.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.createForm();
    this.subs.push(
      this.employeeService.getEmployees().subscribe(employees => {
        this.employees = {};
        const data = employees.reduce((acc, cur) => {
          acc[`${cur.name.trim()} ${cur.lastName.trim()}`] = null;
          this.employees[`${cur.name.trim()} ${cur.lastName.trim()}`] = cur.id$;
          return acc;
        }, {});
        this.employeesInit = { 'data': data };
      })
    );
    this.subs.push(
      this.subsidiaryService.getSubsidiaries().subscribe(subsidiaries => {
        this.subsidiaries = {}
        const data = subsidiaries.reduce((acc, cur) => {
          acc[`${cur.name.trim()}`] = null;
          this.subsidiaries[`${cur.name.trim()}`] = cur.id$;
          return acc;
        }, {});
        this.subsidiariesInit = { 'data': data };
      })
    );
    let subShip = this.shipService.getShip(this.sid).subscribe(([{supervisorObj, subsidiaryObj, ...data}]) => {
      this.ship = data;
      this.shipForm.patchValue({
        ...this.ship,
        supervisorId: supervisorObj ? `${supervisorObj.name.trim()} ${supervisorObj.lastName.trim()}` : '',
        subsidiaryId: subsidiaryObj.name
      });
      subShip.unsubscribe();
      console.log(this.subError, this.supError)
    });
  }

  ngOnDestroy() {
    this.subs.map((sub, index) => {
      this.subs[index].unsubscribe();
    });
  }

  createForm() {
    this.shipForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      lines: '',
      sizeHa: ['', Validators.required],
      supervisorId: ['', Validators.required],
      subsidiaryId: ['', Validators.required]
    });
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    value.supervisorId = this.employees[value.supervisorId];
    value.subsidiaryId = this.subsidiaries[value.subsidiaryId];
    this.shipService.updateShip(this.sid, value);
  }

  get supError(){ return !this.employees[this.shipForm.get('supervisorId').value] }
  get subError(){ return !this.subsidiaries[this.shipForm.get('subsidiaryId').value] }
}
